export default function reducer(state={
    loading:false,
    showAlert:false,
    alertMessage:null,
    alertVarient:'info',        
    pageLoading: false
},action){
switch(action.type){
    case "LOADIND_START":{
        return{...state,loading:true}
    }
    case "LOADIND_END":{ 
        return{...state,loading:false}
    }
    case "SHOW_ALERT":{
        return{...state,showAlert:action.show,alertMessage:action.message,alertVarient:action.varient}
    }   
    
    case "SHOW_LOADER":{
        return {...state,[action.field]:action.status}
    }
    case "STORE_PAGE_LOADING": {
        return {...state,pageLoading:action.bool}
    }
    default:
        break;
}
return state
}